import * as React from "react";

import { cn } from "../../lib/utils";
import { cva, type VariantProps } from "class-variance-authority";

const textareaVariants = cva(
  "jobsite:border-input jobsite:placeholder:text-muted-foreground jobsite:border-2 jobsite:border-border jobsite:focus-visible:border-ring jobsite:focus-visible:ring-ring/50 jobsite:aria-invalid:ring-destructive/20 jobsite:dark:aria-invalid:ring-destructive/40 jobsite:aria-invalid:border-destructive jobsite:dark:bg-input/30 jobsite:flex jobsite:field-sizing-content jobsite:min-h-16 jobsite:w-full jobsite:border jobsite:bg-transparent jobsite:px-3 jobsite:py-2 jobsite:text-base jobsite:transition-[color,box-shadow] jobsite:outline-none jobsite:focus-visible:ring-[3px] jobsite:disabled:cursor-not-allowed jobsite:disabled:opacity-50 jobsite:md:text-sm",
  {
    variants: {
      variant: {
        default: "",
        rounded: "jobsite:rounded-md",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Textarea({
  className,
  variant = "default",
  ...props
}: React.ComponentProps<"textarea"> & VariantProps<typeof textareaVariants>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(textareaVariants({ variant, className }))}
      style={{ borderRadius: "var(--jobsite-radius)" }}
      {...props}
    />
  );
}

export { Textarea };
